import AffirmationService from 'src/modules/affirmation/affirmationService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'AFFIRMATION_VIEW';

const affirmationViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationViewActions.FIND_STARTED,
      });

      const record = await AffirmationService.find(id);

      dispatch({
        type: affirmationViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationViewActions.FIND_ERROR,
      });

      getHistory().push('/affirmation');
    }
  },
};

export default affirmationViewActions;
